var m = require('mithril');
var layout = require('../layout/layout');
var certifiedInstruments = require('./certifiedInstruments');
var certifiedInstrumentEditor = require('./certifiedInstrumentEditor');
var calibrations = require('./calibrations')


module.exports = {
  '/certifiedinstruments': {
    view: () => m(layout, m(certifiedInstruments))
  },
  '/certifiedinstrument/:key': {
    view: () => m(layout, m(certifiedInstrumentEditor))
  },
  '/calibrations': {
    view: () => m(layout, m(calibrations))
  }
};